import React, { useContext, useEffect, useState } from "react";
import HeroBanner from "../component/Home/HeroBanner";
import HomeCategorySection from "../component/Home/HomeCategorySection";
import HomeSaleSection from "../component/Home/HomeSaleSection";
import ProductListSection from "../component/Home/ProductListSection";
import HomeRecommendSection from "../component/Home/HomeRecommendSection";
import HomeBestDealSection from "../component/Home/HomeBestDealSection";
import BestSellsSection from "../component/Home/BestSellsSection";
import TopSellingSection from "../component/Home/TopSellingSection";
import NewArrivalSection from "../component/Home/NewArrivalSection";
import { userContext } from "../context/UserContext";
import { api_url } from "../helpers";
const Home = () => {
  const { user, setLoad } = useContext(userContext);
  const [homeData, setHomeData] = useState([]);

  async function HomePageData() {

    setLoad(true)

    let main_url = ""

    if (user?.name == "guest"){
      main_url = api_url + "method/erp_sn.api.homepage.get_home_page_data"
    }else{
      main_url = api_url + "method/erp_sn.api.homepage.get_home_page_data?email=" + user?.email
    }

    const responsData = await fetch(
      main_url,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      setHomeData(data?.message);
    }

    setTimeout(() => {
      setLoad(false)
    }, 300);
  }

  useEffect(() => {
    HomePageData();
  }, []);

  return (
    <>
      <HeroBanner homeData={homeData} />
      {/* <HomeCategorySection />
      <HomeSaleSection />
      <ProductListSection /> */}
      <HomeRecommendSection homeData={homeData} />
      {/* <HomeBestDealSection />
      <BestSellsSection />
      <TopSellingSection />
      <NewArrivalSection /> */}
    </>
  );
};

export default Home;
